import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Notes thread (roast R08): chronological list of notes_log entries with
 * author + timestamp. Falls back to the legacy single `notes` string when
 * the document predates notes_log.
 */

const formatTimestamp = (iso, locale) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString(locale, {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch (err) {
    return "";
  }
};

const NotesThread = ({ notesLog, legacyNote }) => {
  const { t } = useTranslation();
  const entries = Array.isArray(notesLog) ? notesLog : [];

  if (entries.length === 0 && !legacyNote) {
    return <div className="notes-empty">{t("no_content")}</div>;
  }

  const sorted = [...entries].sort(
    (a, b) => new Date(a.created_at) - new Date(b.created_at)
  );

  return (
    <div className="notes-thread">
      {sorted.map((entry, index) => (
        <div key={index} className="note-entry">
          <div className="note-meta">
            <span>{entry.author_name || t("operatorFallback")}</span>
            <span>{formatTimestamp(entry.created_at, t("currentLanguage"))}</span>
          </div>
          <div className="note-text">{entry.text}</div>
        </div>
      ))}
      {/* legacy single note kept visible for pre-notes_log documents */}
      {entries.length === 0 && legacyNote && (
        <div className="note-entry">
          <div className="note-text">{legacyNote}</div>
        </div>
      )}
    </div>
  );
};

export default NotesThread;
